import * as React from 'react';
import { PriceType } from '../../../classes/price-type';
import { CartSeat, Seat, SeatPriceQuantity, SeatZone } from '../../../classes/seat';
import { SeatingOption } from '../../../classes/seating-option';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import { ISeatMapModel } from '../../reducers/seatmap-reducer';
import ConfirmPrompt from './confirm-prompt';
import SeatInfoNotice from './seat-info-error';
import SeatInfoHeaderContainer from './seat-info-header-container';
import SeatInfoOptionsContainer from './seat-info-options-container';
import SeatInfoPrices from './seat-info-prices';
import { isPad } from '../../../helpers/is-mobile';
import { checkSpecialSeatingSeatLimit } from '../../actions/seatmap-actions';
import { ZoneUpsell } from '../../../classes/zone-upsell';
import ZoneUpsellContainer from './zone-upsell-container';
import SeatInfoImage from './seat-info-image';

export interface ISeatingInfoProps {
    appSettingsModel: IAppSettingsModel;
    cartSeats: Array<CartSeat>;
    selectedPriceTypes: Array<PriceType>;
    activeSeats: Array<Seat>;
    levelPricing: Array<SeatZone>;
    dispatch: any;
    viewFromSeatModalActive: boolean;
    maxQuantityPriceTypeError: boolean;
    minQuantityPriceTypeError: boolean;
    minQuantityPriceTypeSelectedErrorTextReplace: string;
    maxQuantitySeatingOptionError: boolean;
    flexQuantityPriceTypeError: boolean;
    flexMinQuantityError: boolean;
    flexMaxQuantityErrorAllTickets: boolean;
    flexMaxQuantityErrorPriceType: boolean;
    seatmapModel: ISeatMapModel;
    isGAZone?: boolean;
    isSingleClick: boolean;
    selectedSeatingOptions: SeatingOption[];
    hasConfirmPrompt: boolean;
    isExchange: boolean;
    isInCart: boolean;
    isSelectedSeat: boolean;
    onCancelConfirmClick: () => void;
    onConfirmSeatClick: () => void;
    onSelectPricing: (priceQuantities: Array<SeatPriceQuantity>) => void;
    onSelectSeatingOption: () => void;
    onSelectSeatClick: () => void;
    onSelectSeatDisabledClick: () => void;
    onSelectSeatInCartClick: () => void;
    onToggleSeatingInfoOpen: () => void;
    selectedPriceQuantities: SeatPriceQuantity[];
    needPriceTypeError: boolean;
    needSeatingOptionError: boolean;
    noMoreExchangeableTicketsError: boolean;
    selectedSeatsPreferenceUpdated: boolean;
    confirmPromptText: string;
    exchangeTicketsRemaining: number;
    additionalPurchasable: number;
    showSeatingInfo: boolean;
    selectedPriceTypeQuantities: Array<SeatPriceQuantity>;
    onCloseZoneUpsell: () => any;
    seats: Array<Seat>;
    zoneUpsell: ZoneUpsell;
    hidingUpsell: boolean;


}

class SeatingInfo extends React.Component<ISeatingInfoProps, null>{
    static defaultProps = {
        isGAZone: false,
    }

    render() {
        const {
            isSingleClick,
            hasConfirmPrompt,
            isInCart,
            isSelectedSeat,
            selectedPriceTypes,
            onSelectPricing,
            selectedPriceQuantities,

        } = this.props;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;
        const useTag = `<use xlink:href="#icon-arrow-down" />`;
        const showConfirmPrompt = (!isSingleClick && hasConfirmPrompt && isSelectedSeat && !isInCart);
        return (

            <div className={"seat-info-container"}>

                <div className="seat-info-container-header seat-info-container-header-desktop">
                    <button type="button" className="sidebar-section-toggle" onClick={this.props.onToggleSeatingInfoOpen} aria-expanded={this.props.showSeatingInfo}>
                        <h2 className="heading-general" tabIndex={-1}>{this.props.isGAZone ? this.props.appSettingsModel.seatmapSelectedZoneText : this.props.appSettingsModel.seatmapSelectedSeatText}</h2>
                        <div dangerouslySetInnerHTML={{ __html: xSvg }} ></div>
                    </button>
                </div>

                <div className="seat-info-container-header seat-info-container-header-mobile">
                    <button type="button" className="sidebar-section-toggle" onClick={this.props.onToggleSeatingInfoOpen} aria-expanded={this.props.showSeatingInfo}>
                        {/*TODO: dynamic text*/}
                        <span className="visually-hidden">Toggle Selected Seat View</span>
                        <svg className={"filters-section-heading-toggles-icon"} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                        <h2 className="heading-general">{this.props.isGAZone ? this.props.appSettingsModel.seatmapSelectedZoneText : this.props.appSettingsModel.seatmapSelectedSeatText}</h2>
                    </button>
                </div>

                <div className={"seat-info-container-main"}>
                    {
                        showConfirmPrompt
                            ? this.renderConfirmPrompt()
                            : this.renderSeatingInfo()
                    }
                </div>

                <div className="seat-info-footer">
                    {
                        (this.props.activeSeats[0].tessituraSeat.isAvailable && !showConfirmPrompt) ?
                            <SeatInfoPrices
                                selectedPriceTypes={selectedPriceTypes}
                                onSelectPricing={onSelectPricing}
                                selectedPriceQuantities={selectedPriceQuantities}
                            />
                            : null
                    }

                    {
                        //!isSingleClick &&
                        this.props.activeSeats[0].tessituraSeat.isAvailable
                        && this.renderSelectButton()
                    }
                </div>

                {(!this.props.hidingUpsell) ?
                    <ZoneUpsellContainer {...this.props}
                        dispatch={this.props.dispatch}
                        appSettingsModel={this.props.appSettingsModel}
                        venueLevels={this.props.appSettingsModel.venueLevels}
                        zoneUpsell={this.props.zoneUpsell}
                        cartSeats={this.props.cartSeats}
                        seats={this.props.seats}
                        onCloseZoneUpsell={this.props.onCloseZoneUpsell}
                        selectedPriceTypeQuantities={this.props.selectedPriceTypeQuantities}
                    />
                    : null
                }
            </div>
        );
    }

    renderConfirmPrompt() {
        return <ConfirmPrompt appSettingsModel={this.props.appSettingsModel} confirmPromptText={this.props.confirmPromptText}
            onCancelSeatClick={this.props.onCancelConfirmClick}
            onConfirmSeatClick={this.props.onConfirmSeatClick} />
    }

    renderSeatingInfo() {
        const {
            isExchange,
            dispatch,
            levelPricing,
            activeSeats,
            appSettingsModel,
            selectedPriceTypes,
            onSelectPricing,
            onSelectSeatingOption,
            selectedPriceQuantities,
            selectedSeatingOptions,
            cartSeats,
            seatmapModel,
            flexQuantityPriceTypeError,
            needSeatingOptionError,
            needPriceTypeError,
            noMoreExchangeableTicketsError,
            exchangeTicketsRemaining,
            additionalPurchasable
        } = this.props;

        return (
            <div className="seat-info-main">
                <div className="seat-info-top">
                    {
                        !this.props.seatmapModel.hasSeatViewImages || (isPad() && this.props.appSettingsModel.disableMobileViewFromSeat) ? null :
                            <SeatInfoImage
                                {...this.props}                                                                
                                seatViewImageId={this.props.activeSeats[0].seatViewImageId}
                                viewFromSeatModalActive={this.props.viewFromSeatModalActive}
                                altText={this.props.appSettingsModel.altText}                                                                                                
                                seatViewCaptionText={this.props.appSettingsModel.viewFromSeatCaptionText}
                            />
                    }

                    <SeatInfoHeaderContainer seat={this.props.activeSeats[0]}
                        isInCart={this.props.isInCart}
                        inCartSeatStyle={this.props.seatmapModel.seatStyles.find(sty => sty.id === this.props.activeSeats[0].inCartSeatStyleId)}
                        useZoneDescription={appSettingsModel.useZoneDescription}
                        seatViewCaptionText={this.props.appSettingsModel.viewFromSeatCaptionText}
                        isGAZone={this.props.isGAZone}
                    />
                </div>

                <SeatInfoNotice {...appSettingsModel}
                    {...this.props}
                    exchangeTicketsRemaining={exchangeTicketsRemaining}
                    additionalPurchasable={additionalPurchasable}
                    needPriceTypeError={needPriceTypeError}
                    needSeatingOptionError={needSeatingOptionError}
                    noMoreExchangeableTicketsError={noMoreExchangeableTicketsError}
                    maxQuantityPriceTypeError={this.props.maxQuantityPriceTypeError || this.allPriceTypesMaxedOut}
                    showFlexPriceTypeError={flexQuantityPriceTypeError}
                    flexMaxQuantityError={this.props.flexMaxQuantityErrorAllTickets}
                    minQuantityPriceTypeError={this.props.minQuantityPriceTypeError}
                    minQuantityPriceTypeSelectedErrorTextReplace={this.props.minQuantityPriceTypeSelectedErrorTextReplace}
                    priceTypeMinQuantityRequiredMessage={this.props.appSettingsModel.minimumSeatsSingleTicketRequiredMessage}
                />
                {
                    this.props.activeSeats[0].tessituraSeat.isAvailable ?
                        <SeatInfoOptionsContainer {...this.props}
                            requestingSeatView={this.props.seatmapModel.requestingSeatView}
                            seat={this.props.activeSeats[0]}
                            onSelectSeatingOption={onSelectSeatingOption}
                            selectedSeatingOptions={selectedSeatingOptions}
                        />
                        : null
                }

            </div>
        );
    }

    get allPriceTypesMaxedOut() {
        const selectedPricings = [...this.props.selectedPriceQuantities.filter(pq => pq.quantity > 0)] as Array<SeatPriceQuantity>;
        if (selectedPricings.length == 0)
            return false;

        return selectedPricings.every(selectedPricing => {
            let selectedPriceTypeMaxQuantity = this.props.appSettingsModel.priceTypeSettings.filter(pt => {
                return pt.priceTypeId === selectedPricing.seatPricing.priceTypeId;
            })[0].clientMaxQuantity;

            var numberOfTicketsInCart = this.props.cartSeats.length;

            if (numberOfTicketsInCart >= this.props.appSettingsModel.maxTicketQuantity)
                return true;

            var numberOfPriceTypeTicketsInCart = this.props.cartSeats.filter(cs => cs.selectedPricing.priceTypeId == selectedPricing.seatPricing.priceTypeId).length;

            return (selectedPriceTypeMaxQuantity !== 0 && (selectedPricing.quantity > selectedPriceTypeMaxQuantity
                || numberOfPriceTypeTicketsInCart >= selectedPriceTypeMaxQuantity))

        });
    }

    renderSelectButton() {
        if (this.props.hasConfirmPrompt && this.props.isSelectedSeat && !this.props.isInCart) {
            return null;
        }

        const cartButton = () => {
            const inCartMessage = this.props.isGAZone ? this.props.appSettingsModel.groupSeatsInCartMessage : this.props.appSettingsModel.seatIsInCartMessage;

            var specialSeatingCheck = checkSpecialSeatingSeatLimit(this.props.activeSeats[0], this.props.cartSeats);
            const requiresAdditionalInput = this.props.selectedPriceQuantities.filter(pq => pq.quantity > 0).length == 0 || this.props.needSeatingOptionError;
            const cannotAddToCart = requiresAdditionalInput || !specialSeatingCheck /*|| this.props.maxQuantityPriceTypeError*/
                || this.allPriceTypesMaxedOut || this.props.flexMaxQuantityErrorPriceType;

            if (!this.props.isInCart) {
                if (cannotAddToCart && !requiresAdditionalInput) {
                    return <>
                        {
                            this.renderCartButton(this.props.appSettingsModel.addToCartButtonText, cannotAddToCart,
                                cannotAddToCart ? this.props.onSelectSeatDisabledClick : this.props.onSelectSeatClick)
                        }
                        {
                            this.renderCartButton(this.props.appSettingsModel.viewCartButtonText, false,
                                this.props.onSelectSeatInCartClick)
                        }
                    </>
                } else {
                    return this.renderCartButton(this.props.appSettingsModel.addToCartButtonText, cannotAddToCart,
                        cannotAddToCart ? this.props.onSelectSeatDisabledClick : this.props.onSelectSeatClick);
                }
            }
            if (this.props.selectedSeatsPreferenceUpdated) {
                return this.renderCartButton(this.props.appSettingsModel.updateCartButtonText, false,
                    this.props.onSelectSeatClick);
            }

            return this.renderCartButton(this.props.appSettingsModel.viewCartButtonText, false,
                this.props.onSelectSeatInCartClick);
        }

        return (
            <div className="seat-info-select-container" onTouchMove={function (evt) { evt.preventDefault(); }}>
                {
                    this.props.isInCart ?
                        <p className="seat-info-container-cart-message">
                            {this.props.isGAZone ? this.props.appSettingsModel.groupSeatsInCartMessage : this.props.appSettingsModel.seatIsInCartMessage}
                        </p>
                        : null
                }
                {cartButton()}
            </div>
        );
    }

    renderCartButton(text: string, disabled: boolean, clickFunction: () => any) {
        return <button className={"seat-info-container-btn"} onClick={clickFunction} disabled={disabled}>
            {text}
        </button>
    }
}

export default SeatingInfo;
